import React from 'react';
import PropTypes from 'prop-types';

import { TextField } from './GradeInput.styled';

const GradeInputField = ({
  inputAdornment,
  onBlur,
  onChange,
  onClick,
  grade,
  label,
  width,
  error,
}) => {
  const handleClick = (e) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <TextField
      variant="outlined"
      margin="dense"
      inputAdornment={inputAdornment}
      InputProps={{
        endAdornment: inputAdornment,
      }}
      onBlur={onBlur}
      onChange={onChange}
      onClick={handleClick}
      value={grade}
      aria-label={label}
      width={width}
      name="grade-input"
      error={error}
    />
  );
};

GradeInputField.propTypes = {
  onClick: PropTypes.func,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  grade: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  inputAdornment: PropTypes.node,
  label: PropTypes.string,
  width: PropTypes.number,
  error: PropTypes.bool,
};

GradeInputField.defaultProps = {
  grade: '',
  inputAdornment: null,
  label: '',
  width: 200,
  onClick: () => {},
  error: false,
};

export default GradeInputField;
